import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { OrderDetailPage } from '@/features/orders/order-detail'

export const Route = createFileRoute('/_authenticated/orders/$orderId')({
  component: () => (
    <RequirePermission permission='orders.read'>
      <OrderDetailPage />
    </RequirePermission>
  ),
})
